import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * This validator should be attached at the formGroup level
 */
export function fieldMatchValidator(
  fieldCtrlName: string,
  matchFieldCtrlName: string,
  errorKey = 'fieldsMustMatch'
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const fieldCtrl = group.get(fieldCtrlName);
    const matchFieldCtrl = group.get(matchFieldCtrlName);

    if (!fieldCtrl || !matchFieldCtrl) {
      return null;
    }

    const fieldValue = fieldCtrl.value;
    const matchFieldValue = matchFieldCtrl.value;

    if (fieldValue !== matchFieldValue) {
      matchFieldCtrl.setErrors({ [errorKey]: true });
    } else {
      if (matchFieldCtrl.hasError(errorKey)) {
        const errors = { ...matchFieldCtrl.errors };
        delete errors[errorKey];
        matchFieldCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }

    return null;
  };
}
